import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "@/src/services/iconService";

const IconLicencePointsTwo = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M132.987,191.936c0-17.922,8.283-20.124,27.338-32.762c11.936-7.979,22.834-14.555,22.834-32.922
			c0-17.061-9.16-31.741-31.261-31.741c-24.433,0-34.47,17.634-34.47,32.332l16.133,3.19c0-13.659,6.846-22.037,18.191-22.037
			c10.757,0,15.271,8.665,15.271,18.225c0,17.553-13.963,21.304-32.299,33.064c-11.348,7.341-17.889,13.658-17.889,32.617v13.533
			h66.32v-13.501L132.987,191.936L132.987,191.936z"
        />
        <path
          d="M29.485,287.125c-9.121-0.029-16.556-7.465-16.586-16.574V65.908c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.546,3.453,3.453V270.54c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.361,9.688-9.691V29.461
			c-0.018-5.319-4.367-9.666-9.697-9.68H29.496c-5.325,0.019-9.672,4.364-9.688,9.69V42.72c0,1.907-1.547,3.454-3.453,3.454
			c-1.908,0-3.455-1.546-3.455-3.454V29.461c0.03-9.118,7.459-16.551,16.563-16.586c0.008,0,0.017,0,0.022,0h241.018
			c9.126,0.021,16.566,7.458,16.598,16.574v241.09c-0.03,9.129-7.472,16.564-16.588,16.586H29.485z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.563H33.874c-1.907,0-3.454-1.545-3.454-3.453s1.547-3.455,3.454-3.455H262.67V33.849
			c0-1.907,1.547-3.454,3.454-3.454s3.454,1.546,3.454,3.454V266.11C269.578,268.018,268.03,269.563,266.124,269.563z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsTwo;
